<script>
	import { IS_INTERFACE_VISIBLE, IS_LOADED, IS_LOADING, BUTTON_TEXT, IS_FINISHED } from '../stores.js';
	import Fade from '../Helper/Fade.svelte';
	import Intro from '../Text/Intro.svelte';
	import Instruction from '../Text/Instruction.svelte';
	import Dots from './Dots.svelte';

  let isInterfaceVisible;
  IS_INTERFACE_VISIBLE.subscribe(v => {
    isInterfaceVisible = v;
  });

  let buttonText;
  BUTTON_TEXT.subscribe(v => {
    buttonText = v;
  });

  let isLoaded;
  IS_LOADED.subscribe(v => {
    isLoaded = v;
  });

  let isLoading;
  IS_LOADING.subscribe(v => {
    isLoading = v;
  });

  let isFinished;
  IS_FINISHED.subscribe(v => {
    isFinished = v;
  });

  function start () { window.start(); }

</script>

<div class="page-start" class:isInterfaceVisible={isInterfaceVisible} class:videoIsLoaded={isLoaded} class:isFinished={isFinished}>
	<Dots />
	<Intro />
	<Instruction />
  <div class="message-mobile"><span>To experience the footnotes of the film, please switch to a larger device.</span></div>
	<div class="interface">
	  <button on:click={start} class="play-button btn btn--big" disabled={!isLoaded || isLoading}>
	  	<i class="icon-play"></i>
	  	<Fade text={buttonText} />
	  </button>
	</div>
</div>
